import data from "../../../../../src/CounterLabel/CounterLabel.docs.json";
import * as React from 'react';
export default {
  data,
  React
};